import { matterPaths } from '@/routing/paths'

export function buildLegacyFileViewerUrl(filePath: string, matterId: string | null): string | null {
  if (!matterId) return null

  const relativePath = legacyPathRelativeToCurrentUser(filePath)
  if (!relativePath) return null

  return matterPaths.referenceViewer.legacyFile(matterId, relativePath)
}

function legacyPathRelativeToCurrentUser(filePath: string): string | null {
  const cleanedPath = filePath.trim().replace(/^\/+/, '')
  if (!cleanedPath) return null

  const parts = cleanedPath.split('/').filter(Boolean)
  if (parts.length < 3 || parts[0] !== 'users') return null

  return parts.slice(2).join('/')
}
